"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleInternalApi = void 0;
const ApiBase_1 = require("../Implementation/ApiBase");
class ScheduleInternalApi extends ApiBase_1.ApiBase {
    /**
     * Fires Schedule Triggered event
     */
    fireScheduleTriggeredEvent(schedule) {
        const adaptableApi = this.getAdaptableApi();
        const scheduleTriggeredInfo = {
            adaptableApi: adaptableApi,
            userName: adaptableApi.optionsApi.getUserName(),
            adaptableId: adaptableApi.optionsApi.getAdaptableId(),
            schedule: schedule,
        };
        adaptableApi.eventApi.emit('ScheduleTriggered', scheduleTriggeredInfo);
    }
}
exports.ScheduleInternalApi = ScheduleInternalApi;
